import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import PictureGallery from './PictureGallery';

const PictureGalleryContainer = ({ pageType }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    let fetchUrl = '';

    if (pageType === 'phrases') {
      fetchUrl = 'https://www.jaymesyoung.com/api/phrases';
    } else {
      fetchUrl = 'https://www.jaymesyoung.com/api/places';
    }

    fetch(fetchUrl)
      .then((reponse) => reponse.json())
      .then((responseData) => {
        if (responseData.status === 'success') {
          setData(responseData.data);
          setLoading(false);
        } else {
          setError(true);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error fetching and parsing data", error);
        setError(true);
        setLoading(false);
      });
  }, [pageType]);

  return (
    <div>
      <PictureGallery
        pageType={pageType}
        error={error}
        loading={loading}
        data={data}
      />
    </div>
  );
};

PictureGalleryContainer.propTypes = {
  pageType: PropTypes.string,
};

export default PictureGalleryContainer;
